module.exports = ".modal-direct-open-receipts .modal-dialog {\n  max-width: 350px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/teshlumon/open-receipts/deposit-modal.component.css
// module id = ./src/app/admin/teshlumon/open-receipts/deposit-modal.component.css
// module chunks = main